import React, { memo } from "react";
import useInputLengthCounter from "./index.hooks";
import { Typography } from "@material-ui/core";
import cn from "classnames";

type InputLengthCounterProps = {
  maxChars: number;
  currentCount: number;
};

const InputLengthCounter = ({
  maxChars,
  currentCount,
}: InputLengthCounterProps) => {
  const { styles, classes, atomicStyles, displayText } = useInputLengthCounter(
    maxChars,
    currentCount,
  );

  return (
    <div className={styles.counterContainer}>
      <Typography
        className={cn(
          styles.charsCounter,
          currentCount > maxChars ? styles.overflow : null,
        )}
      >
        {displayText}
      </Typography>
    </div>
  );
};

export default memo(InputLengthCounter);
